function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.94939 5.12109H4.90568C3.87695 5.12109 2.89036 5.52976 2.16294 6.25718C1.43552 6.9846 1.02686 7.97119 1.02686 8.99992C1.02686 10.0286 1.43552 11.0152 2.16294 11.7427C2.89036 12.4701 3.87695 12.8787 4.90568 12.8787H6.94939M11.0506 5.12109H13.0943C13.6037 5.12109 14.1081 5.22142 14.5787 5.41635C15.0493 5.61128 15.4769 5.89699 15.8371 6.25718C16.1972 6.61736 16.483 7.04496 16.6779 7.51556C16.8728 7.98616 16.9731 8.49055 16.9731 8.99992C16.9731 9.5093 16.8728 10.0137 16.6779 10.4843C16.483 10.9549 16.1972 11.3825 15.8371 11.7427C15.4769 12.1028 15.0493 12.3886 14.5787 12.5835C14.1081 12.7784 13.6037 12.8787 13.0943 12.8787H11.0506M4.89965 8.99992H13.1003",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.3a00dc02eaebcf4880024b580431b39f.svg";
export { ForwardRef as ReactComponent };